import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, MarkExtension, ExtensionTag, toggleMark, markInputRule, markPasteRule } from '@remirror/core';

var _dec, _class, _temp;
var ItalicExtension = (_dec = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec(_class = (_temp = class ItalicExtension extends MarkExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tags", [ExtensionTag.FontStyle]);
  }

  get name() {
    return 'italic';
  }

  createMarkSpec(extra) {
    return {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'i',
        getAttrs: extra.parse
      }, {
        tag: 'em',
        getAttrs: extra.parse
      }, {
        style: 'font-style=italic'
      }],
      toDOM: mark => ['em', extra.dom(mark), 0]
    };
  }

  createKeymap() {
    return {
      'Mod-i': toggleMark({
        type: this.type
      })
    };
  }

  createCommands() {
    return {
      /**
       * Toggle the italic formatting on the selected text.
       */
      toggleItalic: range => toggleMark({
        type: this.type,
        range
      })
    };
  }

  createInputRules() {
    return [markInputRule({
      regexp: /(?:^|[^*])\*([^*]+)\*$/,
      type: this.type,
      ignoreWhitespace: true,
      updateCaptured: (_ref) => {
        var fullMatch = _ref.fullMatch,
            start = _ref.start;
        return !fullMatch.startsWith('*') ? {
          fullMatch: fullMatch.slice(1),
          start: start + 1
        } : {};
      }
    }), markInputRule({
      regexp: /(?:^|[^_])_([^_]+)_$/,
      type: this.type,
      ignoreWhitespace: true,
      updateCaptured: (_ref2) => {
        var fullMatch = _ref2.fullMatch,
            start = _ref2.start;
        return !fullMatch.startsWith('_') ? {
          fullMatch: fullMatch.slice(1),
          start: start + 1
        } : {};
      }
    })];
  }

  createPasteRules() {
    return [markPasteRule({
      regexp: /_([^_]+)_/g,
      type: this.type
    }), markPasteRule({
      regexp: /\*([^*]+)\*/g,
      type: this.type
    })];
  }

}, _temp)) || _class);

export { ItalicExtension };
